<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_x"></a><a id="page_xi"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table class="abbre">
<tbody><tr>
<td class="tdleft">AC</td>
<td class="tdleft">Augsburg Confession, in <i>The Book of Concord: The Confessions of the Evangelical Lutheran Church</i>. Edited by Robert Kolb and Timothy J. Wengert. Minneapolis: Fortress, 2000</td>
</tr>
<tr>
<td class="tdleft">Ap</td>
<td class="tdleft">Apology for the Augsburg Confession, in <i>The Book of Concord: The Confessions of the Evangelical Lutheran Church</i>. Edited by Robert Kolb and Timothy J. Wengert. Minneapolis: Fortress, 2000</td>
</tr>
<tr>
<td class="tdleft"><i>BC</i></td>
<td class="tdleft"><i>The Book of Concord: The Confessions of the Evangelical Lutheran Church</i>. Edited by Robert Kolb and Timothy J. Wengert. Minneapolis: Fortress, 2000</td>
</tr>
<tr>
<td class="tdleft">CCCM</td>
<td class="tdleft">Corpus Christianorum: Continuatio Mediaevalis. Turnhout: Brepols, 1969–</td>
</tr>
<tr>
<td class="tdleft"><i>CR</i></td>
<td class="tdleft"><i>Philippi Melanthonis opera quae supersunt Omnia</i>. Edited by Karl Bretschneider and Heinrich Bindseil. Vols. 1–28 of <i>Corpus Reformatorum</i>. Halle: A. Schwetschke and Sons, 1834–1860</td>
</tr>
<tr>
<td class="tdleft">CSEL</td>
<td class="tdleft">Corpus Scriptorum Ecclesiasticorum Latinorum. Vienna, 1866–</td>
</tr>
<tr>
<td class="tdleft">FC</td>
<td class="tdleft">Formula of Concord, in <i>The Book of Concord: The Confessions of the Evangelical Lutheran Church</i>. Edited by Robert Kolb and Timothy J. Wengert. Minneapolis: Fortress, 2000</td>
</tr>
<tr>
<td class="tdleft">FC SD</td>
<td class="tdleft">Formula of Concord, Solid Declaration, in <i>The Book of Concord: The Confessions of the Evangelical Lutheran Church</i>. Edited by Robert Kolb and Timothy J. Wengert. Minneapolis: Fortress, 2000</td>
</tr>
<tr>
<td class="tdleft">HC</td>
<td class="tdleft">Heidelberg Catechism, in <i>Reformed Confessions in the Sixteenth Century.</i> Edited by Arthur Cochrane. Louisville: Westminster John Knox, 2003</td>
</tr>
<tr>
<td class="tdleft"><i><a id="page_xii">LW</a></i></td>
<td class="tdleft"><i>Luther’s Works</i>. American Edition. 55 vols. Saint Louis: Concordia; Philadelphia: Fortress, 1955–1986, 2010–</td>
</tr>
<tr>
<td class="tdleft"><i>MBW</i></td>
<td class="tdleft"><i>Melanchthons Briefwechsel: Kritische und kommentierte Gesamtausgabe</i>. Edited by Heinz Scheible. Stuttgart–Bad Cannstatt: Frommann-Holzboog, 1977</td>
</tr>
<tr>
<td class="tdleft"><i>MW</i></td>
<td class="tdleft"><i>Melanchthons Werke in Auswahl</i>. Edited by Hans Engelland and Robert Stupperich. Gütersloh: C. Bertelsmann, 1951</td>
</tr>
<tr>
<td class="tdleft"><i>OE</i></td>
<td class="tdleft"><i>Ioannis Calvini Opera Omnina</i>. Series II: <i>Opera Exegetica</i>. Edited by Helmut Feld. Geneva: Librairie Droz, 1992–</td>
</tr>
<tr>
<td class="tdleft">PG</td>
<td class="tdleft">Patrologia Graeca. Edited by J.-P. Migne. 162 vols. Paris, 1857–1886</td>
</tr>
<tr>
<td class="tdleft">PL</td>
<td class="tdleft">Patrologia Latina. Edited by J.-P. Migne. 221 vols. Paris, 1844–1864</td>
</tr>
<tr>
<td class="tdleft"><i>SPT</i></td>
<td class="tdleft"><i>Synopsis Purioris Theologiae: Synopsis of a Purer Theology.</i> Latin Text and English Translation. Vol. 1, <i>Disputations 1–23</i>. Edited by Dolf te Velde. Studies in Medieval and Reformation Traditions 187. Leiden: Brill, 2014</td>
</tr>
<tr>
<td class="tdleft"><i>ST</i></td>
<td class="tdleft">Thomas Aquinas. <i>Summa Theologiae</i>. Latin Text and English translation, introduction notes, appendices, and glossaries. 60 vols. London: Blackfriars; Eyre and Spottiswoode, 1962–1980</td>
</tr>
<tr>
<td class="tdleft">WA</td>
<td class="tdleft"><i>D. Martin Luthers Werke. Kritische Gesamtausgabe. Schriften</i>. 73 vols. Weimar: H. Böhlau, 1883–2009</td>
</tr>
<tr>
<td class="tdleft">WABr</td>
<td class="tdleft"><i>D. Martin Luthers Werke. Kritische Gesamtausgabe. Briefwechsel</i>. 18 vols. Weimar: H. Böhlau, 1930–1985</td>
</tr>
<tr>
<td class="tdleft">WADB</td>
<td class="tdleft"><i>D. Martin Luthers Werke. Kritische Gesamtausgabe. Die deutsche Bibel</i>. 15 vols. Weimar: H. Böhlau, 1906–1961</td>
</tr>
<tr>
<td class="tdleft">WATr</td>
<td class="tdleft"><i>D. Martin Luthers Werke. Kritische Gesamtausgabe. Tischreden</i>. 6 vols. Weimar: H. Böhlau, 1912–1921</td>
</tr>
<tr>
<td class="tdleft">WCF</td>
<td class="tdleft">Westminster Confession of Faith, in <i>Westminster Confession of Faith</i>. Glasgow: Free Presbyterian Publications, 1995</td>
</tr>
<tr>
<td class="tdleft">WLC</td>
<td class="tdleft">Westminster Larger Catechism, in <i>Westminster Confession of Faith</i>. Glasgow: Free Presbyterian Publications, 1995</td>
</tr>
<tr>
<td class="tdleft">WSC</td>
<td class="tdleft">Westminster Shorter Catechism, in <i>Westminster Confession of Faith</i>. Glasgow: Free Presbyterian Publications, 1995</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?1bc0d419